import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { EmailRegxValidator } from '../../../utils';
import { ForgotPassword } from '../../../apis/Admin/Profile/ForgotPassword';
// import BrandNewPasswordFormComponent from './BrandNewPasswordFormComponent';
import { Link } from 'react-router-dom';
import NewPasswordFormComponent from './NewPasswordFormComponent';

const { Item } = Form;
const ResetPasswordFormComponent = () => {
  const [brandResetPassword] = Form.useForm();
  const [resetEmail, setResetEmail] = useState('');
  const [apiValidation, setApiValidation] = useState({
    success: false,
    points: [],
  });
  const onFinish = (values) =>{
    ForgotPassword(values).then(({ response, status }) => {
      if (status === 200) {
        console.log('response ==> email', response);
        message.success(response.msg);
        setApiValidation({
          ...apiValidation,
          success: true,
          points: [],
        });
        setResetEmail(values.email);
      } else {
        console.log('respone', response);
        setApiValidation({
          ...apiValidation,
          success: false,
          points: response.errors,
        });
      }
    });
  };

  return (
    <div>
      {!apiValidation.success ?(
        <>
          <Form
            form={brandResetPassword}
            name="brandResetPassword"
            layout="vertical"
            className="login-form pt-2"
            requiredMark={false}
            // initialValues={{
            //     remember: true,
            // }}
            onFinish={onFinish}
          >
            <Item
              label="please enter your Registred Email ID"
              name="email"
              rules={[
                { required: true, message: 'Please provide your Email ID!' },
                () =>({
                  validator (_, value) {
                    if (value && !EmailRegxValidator(value)) {
                      return Promise.reject(new Error('Please provide a valid Email ID'));
                    } else if (value && (value.indexOf('@4monks.in') === -1) ) {
                      return Promise.reject(new Error('Not a valid Admin Email ID'));
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}

            >
              <Input
                size="large"
                className="common_input"

                type="text"
                placeholder="name@flynt.social"
                prefix={<MailOutlined className="site-form-item-icon mr-1" />}/>
            </Item>
            <Item>
              <Button htmlType="submit"
                className="common_button">Get reset token</Button>
              <Link to="/admin"><Button className="common_button ml-3">Signin</Button></Link>
            </Item>
          </Form>
          {
            /* @note: error mesagges from API */
            apiValidation.points.length ?
              <div>
                <p className="text-danger mb-1"><strong>Failed to Sign In due to following reasons:</strong></p>
                <ul className="pl-3">
                  {apiValidation.points.map(({ msg }, index) =>(
                    <li key={index}
                      className="text-danger">{msg}</li>
                  ))}
                </ul>
              </div> :
              null
          }
        </>
      ):(
      // <BrandNewPasswordFormComponent resetEmail={resetEmail}/>
        <NewPasswordFormComponent resetEmail={resetEmail}/>
      )
      }

    </div>
  );
};

export default ResetPasswordFormComponent;
